import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const NavDokumentIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 18" sx={{ fill: 'none', ...props.sx }}>
      <path
        d="M4.63267 11.1862L6.05742 8.45694C6.21231 8.15214 6.44792 7.89474 6.73903 7.71234C7.03015 7.53004 7.36582 7.42954 7.71013 7.42164H17.9303M17.9303 7.42164C18.2205 7.42114 18.507 7.48654 18.7677 7.61274C19.0284 7.73904 19.2565 7.92274 19.4344 8.14994C19.6123 8.37714 19.7354 8.64164 19.7941 8.92334C19.8527 9.20494 19.8455 9.49614 19.773 9.77454L18.3102 15.4215C18.2044 15.8277 17.9647 16.1872 17.6291 16.4429C17.2936 16.6987 16.8814 16.8361 16.4581 16.8333H2.73301C2.22918 16.8333 1.746 16.6349 1.38974 16.2819C1.03348 15.9289 0.833335 15.4501 0.833335 14.9509V2.71577C0.833335 2.21654 1.03348 1.73776 1.38974 1.38475C1.746 1.03175 2.22918 0.833426 2.73301 0.833426H6.43736C6.75506 0.830336 7.06847 0.906266 7.3489 1.05425C7.62934 1.20223 7.86783 1.41754 8.04257 1.68048L8.81193 2.80988C8.98493 3.07015 9.22044 3.28378 9.49724 3.43162C9.77414 3.57947 10.0836 3.65689 10.3981 3.65694H16.0306C16.5345 3.65694 17.0176 3.85525 17.3739 4.20826C17.7302 4.56127 17.9303 5.04005 17.9303 5.53927V7.42164Z"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default NavDokumentIcon;
